import CustomAttributeFilterProduct from '/src/_includes/graphql/examples/custom-attribute-filter-product.md';
import * as React from 'react';
export default {
  CustomAttributeFilterProduct,
  React
};